import { ECartType, EItemGroup, IEcommerceProduct } from '@services/ecommerceService';
import { ISmallProductProps } from '@sharedComponents/Products';
import { getPriceWithoutVat } from '@utils/math';
import { getProductGroup, isProductAvailable } from '@utils/product';

import { IProduct } from '../../model';

export const createEcommerceProduct = (product: IProduct): IEcommerceProduct => ({
  productId: product.productId,
  productCode: product.productCode,
  productName: product.name,
  vat: product.vat,
  brandName: product.brandName,
  price: Math.round((getPriceWithoutVat(product.priceWithVat, product.vat) + Number.EPSILON) * 100) / 100,
  fullPrice: product.priceWithVat,
  quantity: product.count,
  variantName: product.variant,
  stockAvailability: isProductAvailable(product),
  group: getProductGroup(product),
  cartType: ECartType.Cart,
  primaryCategories: product.primaryCategories,
  annotation: product.annotation,
  additionalVariantInfo: product.additionalVariantInfo,
});

export const createEcommerceFromSmallProduct = (product: ISmallProductProps): IEcommerceProduct => ({
  productId: product.product.productId,
  productCode: product.product.productCode,
  productName: product.product.name,
  vat: product.vat ?? 0,
  brandName: product.product.brandName,
  price: Math.round((getPriceWithoutVat(product.price, product.vat ?? 0) + Number.EPSILON) * 100) / 100,
  fullPrice: product.price,
  quantity: product.count,
  variantName: product.product.variantName,
  stockAvailability: isProductAvailable(product.product),
  group: EItemGroup.PRODUCT,
  cartType: ECartType.Cart,
  primaryCategories: product.product.primaryCategories,
  annotation: product.product.annotation,
  additionalVariantInfo: product.product.additionalVariantInfo,
});
